<template>
  <div class="home">
    <!-- banner区域 -->
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="slide1">
          <!-- 活动报名 -->
          <!-- <img
            @click="routeJump('contestRegistration', 1)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_1.png"
            alt=""
          /> -->
          <img v-if="imgStatus === 'zhSimple'" @click="routeJump('/contestRegistration', 1)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_middle_zhSimple.png" alt="" />
          <img v-if="imgStatus === 'zhComplex'" @click="routeJump('/contestRegistration', 1)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_middle_zhComplex.png" alt="" />
          <img v-if="imgStatus === 'en'" @click="routeJump('/contestRegistration', 1)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_middle_en.png" alt="" />
        </swiper-slide>
        <swiper-slide>
          <!-- <img
            @click="routeJump('contestRegistration', 2)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_middleSchool.png"
            alt=""
          /> -->
          <img v-if="imgStatus === 'zhSimple'" @click="routeJump('/contestRegistration', 2)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_college_zhSimple.png" alt="" />
          <img v-if="imgStatus === 'zhComplex'" @click="routeJump('/contestRegistration', 2)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_college_zhComplex.png" alt="" />
          <img v-if="imgStatus === 'en'" @click="routeJump('/contestRegistration', 2)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_college_en.png" alt="" />
        </swiper-slide>
        <!-- <swiper-slide>
          <img
            @click="routeJump('contestRegistration', 3)"
            src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/banner_2.png"
            alt=""
          />
        </swiper-slide> -->
      </swiper>
      <div class="page-change">
        <div class="btn-left"></div>
        <div class="btn-right"></div>
      </div>
    </div>

    <!-- 大赛时间表 -->
    <!-- <div v-if="imgStatus === 'zhSimple'" class="schedule">
      <div class="backg-heading">{{ $t("main.competitionSchedule") }}</div>
      <div class="schedule-imgs">
        <div class="schedule-imgs-item">
          <p class="title">
            {{ $t("main.MiddleSchoolGroupCompetitionProcess") }}
          </p>
          <img src="@/assets/svg/time_process1.svg" alt="" srcset="" />
        </div>
        <div class="schedule-imgs-item">
          <p class="title">
            {{ $t("main.UniversityGroupCompetitionProcess") }}
          </p>
          <img src="@/assets/svg/time_process2.svg" alt="" srcset="" />
        </div>
      </div>
    </div>
    <div v-else-if="imgStatus === 'zhComplex'" class="schedule">
      <div class="backg-heading">{{ $t("main.competitionSchedule") }}</div>
      <div class="schedule-imgs">
        <div class="schedule-imgs-item">
          <p class="title">
            {{ $t("main.MiddleSchoolGroupCompetitionProcess") }}
          </p>
          <img src="@/assets/svg/time_middle_complex.svg" alt="" srcset="" />
        </div>
        <div class="schedule-imgs-item">
          <p class="title">
            {{ $t("main.UniversityGroupCompetitionProcess") }}
          </p>
          <img src="@/assets/svg/time_college_complex.svg" alt="" srcset="" />
        </div>
      </div>
    </div>
    <div v-else="imgStatus === 'en'" class="schedule">
      <div class="backg-heading">{{ $t("main.competitionSchedule") }}</div>
      <div class="schedule-imgs">
        <div class="schedule-imgs-item">
          <p class="title">
            {{ $t("main.MiddleSchoolGroupCompetitionProcess") }}
          </p>
          <img src="@/assets/svg/time_middle_en.svg" alt="" srcset="" />
        </div>
        <div class="schedule-imgs-item">
          <p class="title">
            {{ $t("main.UniversityGroupCompetitionProcess") }}
          </p>
          <img src="@/assets/svg/time_college_en.svg" alt="" srcset="" />
        </div>
      </div>
    </div> -->

    <!-- 大赛直播 -->
    <div v-if="isShowLive" class="live-broadcast">
      <div class="backg-heading live-title">大赛直播</div>
      <div class="iframe">
        <!-- B站 直播 -->
        <!-- <iframe
          style="width: 1000px;height: 570px;"
          :src="liveSrc"
          frameborder="no"
          framespacing="0"
          scrolling="no"
          allow="autoplay; encrypted-media"
          allowfullscreen="true"
        ></iframe> -->

        <!-- YouTobe 直播 -->
        <iframe style="width: 1000px;height: 570px;" :src="liveSrc" :title="LiveTitle" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
    </div>

    <!-- 比赛介绍 -->
    <div class="context-introduce">
      <div class="backg-heading">{{ $t("main.CompetitionIntroduction") }}</div>
      <div class="context-introduce-box">
        <div class="context-introduce-box-left">
          <div class="video-box">
            <div v-show="!autoplay" class="mask">
              <img @click="startVideo" src="../assets/svg/play.svg" alt="" />
            </div>
            <video ref="videoPlayer" id="videoID" controls :autoplay="autoplay" loop name="media">
              <source src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/video/introduce.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="context-introduce-box-right">
          <h2>
            {{ $t("main.KubuqiOfficialWebsite") }}
          </h2>
          <div class="KBQawards" v-html="$t('main.KBQawards')"></div>
          <div class="btns">
            <div class="detail" @click="routeJump('/backgroundOfTheCompetition')">
              {{ $t("main.contextDetaile") }}
            </div>
            <div class="sign" @click="routeJump('/contestRegistration', 1)">
              {{ $t("main.signUpNow") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 奖项 -->
    <div class="awards">
      <div class="backg-heading">{{ $t("main.awards") }}</div>
      <div class="main" :class="[language === 'en' ? 'mian-en' : '']">
        <div>
          <div class="title" v-html="$t('main.middleSchoolGroup')"></div>
          <div class="awards-list">
            <div class="item">
              <div>
                <img src="../assets/svg/medal1.svg" alt="" />
                <span>{{ $t("main.championTeam11") }}</span>
              </div>
              <div>
                {{ $t("main.HKD") }}<span>5000</span>{{ $t("main.andDesertFieldVisits") }}
                <span class="red-icon" style="color: red;">*</span>
              </div>
            </div>
            <div class="item">
              <div>
                <img src="../assets/svg/medal2.svg" alt="" />
                <span>{{ $t("main.runnerUpTeam11") }}</span>
              </div>
              <div>
                {{ $t("main.HKD") }}<span>2000</span>{{ $t("main.andDesertFieldVisits") }}
                <span class="red-icon" style="color: red;">*</span>
              </div>
            </div>
            <div class="item">
              <div>
                <img src="../assets/svg/medal3.svg" alt="" />
                <span>{{ $t("main.thirdPlaceTeam11") }}</span>
              </div>
              <div>
                {{ $t("main.HKD") }}<span>1000</span>{{ $t("main.andDesertFieldVisits") }}
                <span class="red-icon" style="color: red;">*</span>
              </div>
            </div>
            <div class="item">
              <div>
                <img src="../assets/svg/medal4.svg" alt="" />
                <span>{{ $t("main.excellentAwardTeam7") }}</span>
              </div>
            </div>
            <div class="tips">
              {{ $t("main.mostEnthusiasticParticipation1") }}
            </div>
          </div>
        </div>
        <div>
          <div class="title">{{ $t("main.universityInternationalGroup") }}</div>
          <div class="awards-list">
            <div class="item">
              <div>
                <img src="../assets/svg/medal1.svg" alt="" />
                <span>{{ $t("main.championTeam11") }}</span>
              </div>
              <div>
                {{ $t("main.HKD") }}<span>100,000</span>{{ $t("main.andDesertFieldVisits") }}
                <span class="red-icon" style="color: red;">*</span>
              </div>
            </div>
            <div class="item">
              <div>
                <img src="../assets/svg/medal2.svg" alt="" />
                <span>{{ $t("main.runnerUpTeam11") }}</span>
              </div>
              <div>
                {{ $t("main.HKD") }}<span>50,000</span>{{ $t("main.andDesertFieldVisits") }}
                <span class="red-icon" style="color: red;">*</span>
              </div>
            </div>
            <div class="item">
              <div>
                <img src="../assets/svg/medal3.svg" alt="" />
                <span>{{ $t("main.thirdPlaceTeam11") }}</span>
              </div>
              <div>
                {{ $t("main.HKD") }}<span>30,000</span>{{ $t("main.andDesertFieldVisits") }}
                <span class="red-icon" style="color: red;">*</span>
              </div>
            </div>
            <div class="item">
              <div>
                <img src="../assets/svg/medal4.svg" alt="" />
                <span>{{ $t("main.excellentAwardTeam71") }}</span>
              </div>
              <div>{{ $t("main.HKD") }}<span>5000</span></div>
            </div>
          </div>
        </div>
        <!--        <div>-->
        <!--          <div class="title">-->
        <!--            {{ $t("main.universityInternationalGroup1") }}-->
        <!--          </div>-->
        <!--          <div class="awards-list">-->
        <!--            <div class="item">-->
        <!--              <div>-->
        <!--                <img src="../assets/svg/medal1.svg" alt="" />-->
        <!--                <span>{{ $t("main.championTeam11") }}</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                {{ $t("main.HKD") }}<span>100,000</span>{{ $t("main.andDesertFieldVisits") }}-->
        <!--                <span class="red-icon" style="color: red;">*</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="item">-->
        <!--              <div>-->
        <!--                <img src="../assets/svg/medal2.svg" alt="" />-->
        <!--                <span>{{ $t("main.runnerUpTeam11") }}</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                {{ $t("main.HKD") }}<span>50,000</span>{{ $t("main.andDesertFieldVisits") }}-->
        <!--                <span class="red-icon" style="color: red;">*</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="item">-->
        <!--              <div>-->
        <!--                <img src="../assets/svg/medal3.svg" alt="" />-->
        <!--                <span>{{ $t("main.thirdPlaceTeam11") }}</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                {{ $t("main.HKD") }}<span>30,000</span>{{ $t("main.andDesertFieldVisits") }}-->
        <!--                <span class="red-icon" style="color: red;">*</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="item">-->
        <!--              <div>-->
        <!--                <img src="../assets/svg/medal4.svg" alt="" />-->
        <!--                <span>{{ $t("main.excellentAwardTeam71") }}</span>-->
        <!--              </div>-->
        <!--              <div>{{ $t("main.HKD") }}<span>5000</span></div>-->
        <!--            </div>-->
        <!--            <div class="item">-->
        <!--              <div>-->
        <!--                <span>{{ $t("main.DepartureFormHongKongSAR") }} </span>-->
        <!--                <span class="red-icon" style="color: red;">*</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <!-- 最新资讯 -->
    <div class="latest-news">
      <div class="backg-heading">{{ $t("main.latestNews") }}</div>

      <div class="news-list">
        <div class="list-item" v-for="(item, index) in newsList" :key="index" @click="routeJump('/latestNews')">
          <div class="title">
            <span class="dot"></span>
            <span class="ellipsis">{{ item.title }}</span>
          </div>
          <div class="news-content">{{ item.abstractField }}</div>
        </div>
        <div v-if="newsList.length" class="central-white-circle"></div>
        <div v-if="newsList.length" class="cross-box">
          <div class="cross" />
        </div>
        <div v-else style="text-align: center">暂无资讯</div>
      </div>

      <div class="view-more" @click="routeJump('/latestNews')">
        <p>{{ $t("main.seeMore") }}</p>
        <img src="../assets/svg/double-down-arrow.svg" alt="" />
      </div>
    </div>

    <!-- 往届大赛 -->
    <div class="previous-competitions">
      <div class="backg-heading">{{ $t("main.previousCompetitions") }}</div>
      <div class="main">
        <swiper :options="swiperOptionTwo" class="imgs">
          <swiper-slide v-for="(item, index) in 9" :key="index">
            <img
              :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/previousCompetitions/previousCompetitionSwiper/${index + 1}.jpg`"
              alt="" />
          </swiper-slide>
        </swiper>
        <!-- 得奖名单 -->
        <div class="previous-competitions-list">
          <div class="warp-item background">
            <div class="left left-title">
              <span>{{ $t("main.workName") }}</span>
            </div>
            <div class="center">
              <span>{{ $t("main.WinningTeam") }}</span>
              <span>{{ $t("main.Awarded") }}</span>
              <span>{{ $t("main.CompetitionName") }}</span>
            </div>
          </div>
          <vue-seamless-scroll :data="previousCompetitionsList" :class-option="classOption" class="warp">
            <div class="warp-item" v-for="(item, index) in previousCompetitionsList" :key="index">
              <div class="left">
                <span class="dot" />
                <span>{{ item.teamName }}</span>
              </div>
              <div class="center">
                <span>{{ item.school }}</span>
                <span>{{ item.group }}</span>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
        <div class="view-more" @click="routeJump('/previousCompetition')">
          <p>{{ $t("main.seeMore") }}</p>
          <img src="../assets/svg/double-down-arrow.svg" alt="" />
        </div>
      </div>
    </div>

    <!-- 主办机构介绍 -->
    <div class="organizer-introduction">
      <div class="backg-heading">
        {{ $t("main.introductionToTheOrganizer") }}
      </div>
      <div class="main">
        <div>
          <a href="https://hkelionfoundation.org/index.php/zh/" target="_blank" rel="noopener noreferrer">
            <img src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/organizer.png" alt="" />
          </a>
        </div>
        <div>
          <a href="https://treelionfoundation.com/en/foundation.html" target="_blank" rel="noopener noreferrer">
            <img src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/treelion-foundation-2.png" alt="" />
          </a>
        </div>

        <!-- <div>{{ $t("main.introductionToTheOrganizerDetail") }}</div> -->
      </div>
      <div class="view-more" @click="routeJump('/aboutUs')">
        <p>{{ $t("main.seeMore") }}</p>
        <img src="../assets/svg/double-down-arrow.svg" alt="" />
      </div>
    </div>

    <!-- 支持单位 -->
    <div class="support-enterprise">
      <div class="backg-heading">{{ $t("main.supportingEnterprises") }}</div>
      <div class="main">
        <div class="enterprise-logo" v-for="(item, index) in supportList" :key="index">
          <a :href="item.link" target="_blank" rel="noopener noreferrer">
            <img :src="item.img" alt="" class="item-logo-img"/>
          </a>
        </div>
        <!-- <div class="enterprise-logo">
          <a href="https://octsyouth.hk" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/17.svg`" alt="" />
          </a>
        </div> -->
      </div>
      <div class="main1">
        <div class="enterprise-logo">
          <p class="support-title">
            {{ $t("main.OfficialEventManagementPartner") }}
          </p>
          <a href="https://www.baobab-tree-event.com/zh-hant/" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/11.png`" alt="" />
          </a>
        </div>
        <div class="enterprise-logo">
          <p class="support-title">
            {{ $t("main.OfficialAdvisoryServicePartner") }}
          </p>
          <a href="" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/12.png`" alt="" />
          </a>
        </div>
        <div class="enterprise-logo">
          <p class="support-title">
            {{ $t("main.OfficialSocialImpactPartner") }}
          </p>
          <a href="https://www.sogluehk.com/" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/13.png`" alt="" />
          </a>
        </div>
        <div class="enterprise-logo">
          <p class="support-title">
            {{ $t("main.OfficialMentorshipPartner") }}
          </p>
          <a :href="cyberportLink" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/14.png`" alt="" />
          </a>
        </div>
        <div class="enterprise-logo">
          <p class="support-title">
            {{ $t("main.OfficialMentorshipPartner") }}
          </p>
          <a :href="cyberportLink" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/15.png`" alt="" />
          </a>
        </div>
        <div class="enterprise-logo">
          <p class="support-title">
            {{ $t("main.OfficialMentorshipPartner") }}
          </p>
          <a href="https://www.mtr.com.hk/sustainability/ch/home.html" target="_blank" rel="noopener noreferrer">
            <img :src="`https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/16.png`" alt="" />
          </a>
        </div>
      </div>
    </div>

    <!-- 侧边浮窗 -->
    <div class="slider">
      <p class="slider-title">{{ $t("main.sliderTitle") }}</p>
      <img src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/kubuqi/kubuqiAwardsQrCode.png" alt="" srcset="" />
      <p class="slider-sub">{{ $t("main.sliderSubtitle") }}</p>
    </div>

    <!-- 问卷调查弹窗 -->
    <el-dialog :fullscreen="false" :show-close="false" title="" :visible.sync="dialogVisible" width="50%"
      ref="editPasswordForm">
      <img src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/kubuqi/questionnaire%20Survey.png" alt=""
        @click="handleQuestionnaireSurvey" />
    </el-dialog>

    <!-- 第二届库布其比赛弹窗 -->
    <div class="contest-dialog" :style="`height:${contestDialogHeight}px`" v-if="isShowContestDialog">
      <div class="content">
        <main>
          <img @click="handleSecondContest()" src="@/assets/img/second_poster.png" alt="" srcset="" />
          <img class="btn-close" @click="handleCloseContestDialog()" src="@/assets/svg/dialog-close-icon.svg" alt=""
            srcset="" />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getCookie } from "utils/cookie";
import vueSeamlessScroll from "vue-seamless-scroll"; // vue2引入方式
 

import { getArticleList } from '@/api/new_api'
import axios from "axios";
export default {
  name: "Home",
  components: { swiper, swiperSlide, vueSeamlessScroll },
  data() {
    return {
      // 视频播放
      autoplay: true,
      // 图片语言
      imgStatus: "zhComplex",
      // 轮播图配置对象
      swiperOption: {
        loop: true,
        speed: 2000,
        easing: "ease-in-out",
        autoplay: {
          delay: 6000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          //下一张
          nextEl: ".btn-right",
          //上一张
          prevEl: ".btn-left",
        },
      },

      // 轮播图配置对象2
      swiperOptionTwo: {
        slidesPerView: 4,
        centeredSlidesBounds: false,
        loop: true,
        speed: 2000,
        easing: "ease-in-out",
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
      },
      // 最新资讯
      newsList: [],
      // 往届大赛列表
      previousCompetitionsList: [
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.champion")}`,
          school: `${this.$t("main.MunsangCollegeHongKongIsland")}`,
          teamName: `${this.$t("main.TheCulpritOfDesertification")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.runnerUp")}`,
          school: `${this.$t("main.TrueLightGirlsCollege")}`,
          teamName: `${this.$t("main.DoNotWasteZhang")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.ThirdPlaceRunnerUp")}`,
          school: `${this.$t("main.EnpingChamberofCommerceandIndustryLiLinmingMiddleSchool")}`,
          teamName: `${this.$t("main.EsportsSandPreventionStrategy")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.publicToLikeAwards")}`,
          school: `${this.$t("main.christianAndMissionaryAllianceSunKeiSecondarySchool")}`,
          teamName: `${this.$t("main.surprisinglyDesolate")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.CCCFongYunWahSecondarySchool")}`,
          teamName: `${this.$t("main.TheMindOftheSandElf")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.MingChiCollegeOftheChineseChristianChurch")}`,
          teamName: `${this.$t("main.unbalance")}`, // 参赛作品
          date: "2019-08-28",
        },

        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.MingChiCollegeOftheChineseChristianChurch")}`,
          teamName: `${this.$t("main.HumanitySinicization")}`, // 参赛作品
          date: "2019-08-28",
        },

        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.CheungChukShanCollege")}`,
          teamName: `${this.$t("main.LEGOCityDesolationAndLocalization")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.CheungChukShanCollege")}`,
          teamName: `${this.$t("main.DesolateLandAndFragrantLand")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.MissionaryAssociationChenZhuSuhuaMemorialHighSchool")}`,
          teamName: `${this.$t("main.Youthtroubles")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.DiocesanGirlsSchool")}`,
          teamName: `${this.$t("main.WildernessHair")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.ELCHKLutheranSecondarySchool")}`,
          teamName: `${this.$t("main.DesertificationIssues")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.HongKongRedSwastikaSocietyTaiPoSwastikaSecondarySchool")}`,
          teamName: `${this.$t("main.TwoMinutesToUnderstandTheChineseCultureOfTheWilderness")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.HongKongFabricManufacturersAssociationZhuShilinSecondarySchool")}`,
          teamName: `${this.$t("main.HowSeriousIsDesertification")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.LaSalleCollege")}`,
          teamName: `${this.$t("main.DesertEncyclopedia")}`, // 参赛作品
          date: "2019-08-28",
        },

        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.PoLeungKukRocheFoundationMiddleSchool")}`,
          teamName: `${this.$t("main.WhenTheEarthEncountersDesertification")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.EpiscopalLamChoMouSecondarySchool")}`,
          teamName: `${this.$t("main.GlobalWildernessGettoKnowIt")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.EpiscopalWhiteJohnChurchHighSchool")}`,
          teamName: `${this.$t("main.EarthPartyTalkingAboutWasteCake")}`, // 参赛作品
          date: "2019-08-28",
        },

        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.TungWahGroupOfHospitalsKapYanDirectorsCollege")}`,
          teamName: `${this.$t("main.CryingEarth")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.TopTwentyFinalists")}`,
          school: `${this.$t("main.TungWahGroupOfHospitalsQiuZitianMemorialMiddleSchool")}`,
          teamName: `${this.$t("main.TheStrangeSoldierOfWildernessAndBirthday")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.talkAboutDesertificationShortFilmCompetition")}`,
          group: `${this.$t("main.ActivelyParticipatingInSchoolAwards")}`,
          school: `${this.$t("main.LaSalleCollege")}`,
          teamName: "————", // 参赛作品
          date: "2019-08-28",
        },

        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.champion")}`,
          school: `${this.$t("main.schoolInfoOne")}`,
          teamName: `${this.$t("main.CONSTRUCTINGOUTDESERTOPIAKUBUQI")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.runnerUp")}`,
          school: `${this.$t("main.schoolInfoTwo")}`,
          teamName: `${this.$t("main.workName1")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.ThirdPlaceRunnerUp")}`,
          school: `${this.$t("main.HongKongUniversityOfScienceAndTechnology")}`,
          teamName: `${this.$t("main.UtilizinggeneticallyengineeredmicrobialcocktailstotackledesertificationintheKubuqidesert")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.CityUniversityOfHongKong")}`,
          teamName: `${this.$t("main.IoTKubuqiAnEcommercePlatformBringingTheWorldCloserToKubuqi")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.HongKongBaptistUniversity")}`,
          teamName: `${this.$t("main.TheKubuqiAwardDesertificationControlBusinessPlanCompetition")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.Universities")}`,
          teamName: `${this.$t("main.TheArtCapitalofKubuqi")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.TheChineseUniversityofHongKong")}`,
          teamName: `${this.$t("main.KubuqiEnvironmentalProtectionTown")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.CityUniversities")}`,
          teamName: `${this.$t("main.TheKubuqiAwardDesertificationControlBusinessPlan")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.TheUniversityofHongKong")}`,
          teamName: `${this.$t("main.MemoryForest")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.LingnanSchoolinHongKong")}`,
          teamName: `${this.$t("main.DesertificationDesertControlLaw")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.UniversitiesThree")}`,
          teamName: `${this.$t("main.KubuqiDesertControlBusinessPlanAquaponics")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.HongKongBaptistUniversity")}`,
          teamName: `${this.$t("main.KubuqiDesertProvidingYouWithAnInternationalAcademicExchangePlatformforEcologicalEnvironment")}`, // 参赛作品
          date: "2019-08-28",
        },
        {
          name: `${this.$t("main.desertGovernanceEntrepreneurshipCompetition")}`,
          group: `${this.$t("main.otherWorks")}`,
          school: `${this.$t("main.UniversitiesFour")}`,
          teamName: `${this.$t("main.EcoSenseTianyouHeyi")}`, // 参赛作品
          date: "2019-08-28",
        },
      ],
      // 当前语言
      language: "zhComplex",
      // 控制列表滚动速度
      classOption: {
        step: 0.5,
      },
      // 支持单位列表
      supportList: [
        {
          link: "http://big5.locpg.gov.cn/gate/big5/www.locpg.gov.cn/index.htm",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/1.png'
        },
        { 
          link: "https://www.edb.gov.hk/tc/index.html",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/2.png'
         },
        { 
          link: "https://www.investhk.gov.hk/zh-hk.html",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/3.png'
         },
        { 
          link: "http://www.elion.com.cn/",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/4.png'
         },
        { 
          link: "https://treelion.com/index_en.html",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/10.jpg'
         }, 
        { 
          link: "https://www.foe.org.hk/",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/6.png'
         }, 
        { 
          link: "https://www.hk-gf.com/",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/7.png'
         }, 
        { 
          link: "https://ghkmbayarea.org/",
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/8.png'
         },   
        { link: "https://octsyouth.hk" ,
          img:'https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/supportEnterprise/17.svg'
        },
      ],

      // 直播
      LiveTitle: "",
      isShowLive: false, // 是否显示直播
      // 直播链接
      liveSrc: "https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=31224832&quality=0",
      dialogVisible: false, // 是否显示问卷调查弹窗
      timer: null, // 问卷调查计时器
      cyberportLink: "", //支持单位跳转链接
      currentDate: "",
      isShowContestDialog: "",
      contestDialogHeight: "",
      originalOverflow: "",
      
    };
  },

  created() {
    const lastDay = localStorage.getItem("day");
    this.updateWindowSize();
    window.addEventListener("resize", this.updateWindowSize);
    // // 获取当前日期
    // const date = new Date().getTime();
    // const day = new Date().getDate();
    // // 第二届库布其比赛 投票截止日期
    // var targetDate = new Date(2024, 2, 28, 23, 59, 59);
    // var timestamp = targetDate.getTime();
    // if (date < timestamp && lastDay != day) {
    //   this.isShowContestDialog = true;
    //   this.openPopup();
    //   localStorage.setItem("day", day);
    //   localStorage.setItem("step", 1);
    // } else {
    //   console.log("今天已经显示过了");
    // }

    let lang = localStorage.getItem("lang") || "zhComplex";
    this.language = localStorage.getItem('language')
    this.imgStatus = lang;
    if (this.imgStatus == "en") {
      this.cyberportLink = "https://cyberport.hk/en/";
    } else if (this.imgStatus == "zhSimple") {
      this.cyberportLink = "https://cyberport.hk/zh_cn/";
    } else {
      this.cyberportLink = "https://www.cyberport.hk/zh_tw/ ";
    }
    this.getNewsList();
  },
  mounted() {
    // window.addEventListener("mousemove", function() {
    //   let video = this.document.getElementById("videoID");
    //   video.play();
    // });
    this.startVideo();
    this.handleGetLiveInfo();

    // 3s后关闭问卷调查弹窗
    this.timer = setTimeout(() => {
      this.dialogVisible = false;
    }, 3000);

    // 判断时间
    this.checkDisplayPopup();
  },
  methods: {
    updateWindowSize() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // console.log("窗口高度：" + windowHeight);
      setTimeout(() => {
        this.contestDialogHeight = windowHeight;
      }, 100);
    },

    // 显示弹窗时禁止滚动
    openPopup() {
      this.originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },

    // 关闭弹窗时恢复滚动
    closePopup() {
      document.body.style.overflow = this.originalOverflow;
    },

    // 关闭比赛弹窗
    handleCloseContestDialog() {
      this.isShowContestDialog = false;
      this.closePopup();
    },

    // 跳转比赛路由
    handleSecondContest() {
      this.$router.push({
        path: "/secondCompetition",
      });
      this.isShowContestDialog = false;
      this.closePopup();
    },

    // 判断日期
    checkDisplayPopup() {
      const lastDisplayDate = localStorage.getItem("lastDisplayDate");
      // const lastDisplayDate = '2024-01-16';
      const currentDate = new Date().toISOString().split("T")[0];
      if (lastDisplayDate !== currentDate) {
        // this.openPopup();
        // this.isShowContestDialog = true;
        this.isShowContestDialog = false; // 隐藏通知弹窗
        localStorage.setItem("lastDisplayDate", currentDate);
      }
    },

    /** */
    // 获取直播信息
    handleGetLiveInfo() {
      axios
        .get("https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/kubuqi/config.json", {})
        .then((res) => {
          this.liveSrc = res.data.src;
          this.isShowLive = res.data.show;
          this.LiveTitle = res.data.title;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 点击播放视频
    startVideo() {
      this.autoplay = true;
      this.$refs.videoPlayer.play();
    },

    // 路由跳转
    routeJump(url, type) {
      // type有值时为活动报名
      if (type) {
        // 判断用户是否登录
        if (getCookie("token")) {
          this.$router.push({ path: '/pc' + url });
        } else {
          // 请先登录
          this.$message.warning("请先登录！");
          this.$router.push({ path: "/pc/logIn" });
        }
      } else {
        this.$router.push({ path: '/pc' + url });
      }
    },
    // 获取最新资讯
    async getNewsList() {
      const { data } = await getArticleList({
        page_no: 1,
        page_size: 4,
        cid: 3,
        type: this.language
      })
      this.newsList = data?.lists||[]
    },

    // 跳转到问卷调查
    handleQuestionnaireSurvey() {
      console.log(333);
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}

.home .swiper-container {
  position: relative;
  width: 100%;
  // height: 500px;
}

.swiper-slide {
  img {
    cursor: pointer;
    width: 100%;
    // height: 100%;
  }
}

.banner {
  position: relative;
  min-width: 1400px;

  // .slide1 {
  //   position: relative;

  //   .text {
  //     position: absolute;
  //     color: red;
  //     top: 20px;
  //     left: 20px;
  //     z-index: 10;
  //   }
  // }

  .page-change {
    position: absolute;
    right: 259px;
    bottom: 29px;
    z-index: 1;

    .btn-left,
    .btn-right {
      display: inline-block;
      width: 22px;
      height: 22px;
      background: url("../assets/svg/banner-cut.svg");
      transform: rotateY(180deg);
      margin-left: 8px;
      transition: none;

      &:hover {
        transition: none;
        background: url("../assets/svg/banner-cut-active.svg");
        transform: rotateY(0deg);
      }
    }

    .btn-right {
      transform: rotateY(0deg);
      transition: none;

      &:hover {
        transition: none;
        background: url("../assets/svg/banner-cut-active.svg");
        transform: rotateY(180deg);
      }
    }
  }
}

.schedule {
  width: 100%;
  height: 775px;
  background: #f4f5f5;
  margin-top: 50px;
  padding: 30px 0;
  min-width: 1000px;

  &-imgs {
    &-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;

      .title {
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        display: inline-block;
        padding: 6px 32px;
        text-align: center;
        background: rgba(44, 135, 121, 0.3);
        border-radius: 3px;
        border: 1px solid #2c8779;
        color: #2c8779;
        font-size: 16px !important;
        font-weight: 400;
      }

      >img {
        width: 1379px;
        height: 196px;
      }
    }

    &-item:last-child {
      .title {
        margin-top: 50px;
      }

      >img {
        height: 265px;
      }
    }
  }
}

.view-more {
  cursor: pointer;
  text-align: center;
  // margin-top: 40px;
  margin-top: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #666666;

  p {
    margin-bottom: 6px;
    height: 14px;
  }
}

.latest-news {
  width: 1400px;
  margin: 0 auto;
  margin-top: 50px;

  .news-list {
    margin-top: 30px;
    position: relative;

    .central-white-circle {
      width: 12px;
      height: 12px;
      background: #fff;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -6px;
      margin-top: -6px;
      z-index: 1;
    }

    .cross-box {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -30px;
      margin-top: -30px;
    }

    .cross {
      width: 60px;
      height: 60px;
      position: relative;
    }

    .cross::before,
    .cross::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #999;
    }

    .cross::before {
      transform: translateY(-50%);
    }

    .cross::after {
      transform: translateY(-50%) rotate(90deg);
    }

    .list-item {
      width: 700px;
      display: inline-block;
      vertical-align: middle;
      border: 1px solid #fff;
      padding-right: 19px;
      cursor: pointer;
      min-height: 80px;

      .title {
        margin-bottom: 15px;
        display: flex;
        align-items: center;

        >span {
          display: inline-block;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #333333;
          line-height: 22px;
          width: 663px;
        }

        .dot {
          width: 6px;
          height: 6px;
          background: #333333;
          border-radius: 50%;
          margin-right: 10px;
        }
      }

      .news-content {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        letter-spacing: 2px;
        margin-bottom: 21px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        
        -webkit-box-orient: vertical;
      }

      &:nth-child(1) {
        border-bottom: 1px solid #eaeaea;
        border-right: 1px solid #eaeaea;
      }

      &:nth-child(2) {
        border-bottom: 1px solid #eaeaea;
      }

      &:nth-child(3) {
        border-right: 1px solid #eaeaea;
      }

      &:nth-child(2n) {
        padding-left: 19px;
        padding-right: 0;
      }

      &:nth-child(3),
      &:nth-child(4) {
        .news-content {
          margin-bottom: 0px;
        }

        .title {
          padding-top: 21px;
        }
      }
    }
  }
}

.previous-competitions {
  margin-top: 50px;
  padding: 30px 0;
  // height: 667px;
  background: url("https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/previous-competitions-backg.png") no-repeat center;
  background-size: cover;
  min-width: 1000px;

  .backg-heading {
    color: #fff;
  }

  .main {
    width: 1400px;
    margin: 0 auto;
    margin-top: 30px;

    .imgs {
      height: 200px;

      img {
        width: 335px;
        height: 200px;
        margin-left: 10px !important;

        &:nth-child(1) {
          margin: 0;
        }
      }
    }

    .previous-competitions-list {
      padding: 0 0 15px;
      margin-top: 20px;
      background: rgba(19, 19, 19, 0.5);
      border-radius: 3px;

      .warp {
        height: 250px;
        // height: 800px;
        // margin: 0 auto;
        overflow: hidden;

        .highlight {
          widows: 100px;
          height: 30px;
          background: cyan;
        }

        &-item {
          display: flex;
          justify-content: start;
          align-items: center;
          padding: 5px 30px;
          cursor: pointer;

          span {
            display: inline-block;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }

          .left {
            width: 300px;
            display: flex;
            align-items: center;

            >span:nth-child(2) {
              width: 284px;
            }

            .dot {
              width: 6px;
              height: 6px;
              background: #ffffff;
              border-radius: 50%;
              margin-right: 10px;
            }
          }

          .center {
            display: flex;
            justify-content: start;
            align-items: center;
            // width: 700px;
            margin-left: 100px;

            >span:nth-child(2) {
              margin: 0 60px;
            }

            >span {
              display: inline-block;
              width: 200px;
              word-break: break-all;
            }

            >span:last-child {
              width: 400px;
              word-break: break-all;
            }
          }

          .right-title {
            width: 300px;
            display: flex;
            align-items: center;
            justify-content: end;
            margin-right: 32px;

            &-date {
              color: #fff;
            }
          }

          .right {
            width: 300px;
            display: flex;
            align-items: center;
            justify-content: end;

            img {
              margin-right: 3px;
            }

            .date {
              color: #999;
              font-size: 14px;
            }
          }

          &:hover {
            background: rgba(242, 242, 242, 0.1);

            span {
              color: #00ffcd;
            }
          }
        }
      }

      .background {
        background: rgba(44, 135, 121, 0.5);
        // .left-title {
        //   width: 336px;
        // }
      }
    }

    .view-more {
      color: #fff;
    }
  }
}

.organizer-introduction {
  margin-top: 50px;

  .main {
    width: 1400px;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 400px;
      margin-right: 60px;
      margin-left: 74px;

      img {
        width: 410px;
      }

      &:first-child {
        img {
          width: 360px;
        }
      }
    }

    div {
      // width: 846px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      letter-spacing: 1px;
    }
  }
}

// 比赛直播
.live-broadcast {
  margin-top: 50px;

  .live-title {
    margin-bottom: 30px;
  }

  .iframe {
    display: flex;
    justify-content: center;
  }
}

// 比赛介绍
.context-introduce {
  margin-top: 50px;

  .context-introduce-box {
    width: 1400px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;

    &-left {
      width: 45%;
      display: flex;
      justify-content: end;

      .video-box {
        width: 610px;
        height: 340px;
        position: relative;

        .mask {
          position: absolute;
          width: 610px;
          height: 340px;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9;
          cursor: pointer;
        }

        video {
          width: 610px;
          height: 340px;
        }

        img {
          width: 42px;
          height: 42px;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -21px;
          margin-left: -21px;
        }
      }
    }

    &-right {
      width: 45%;
      margin-left: 50px;

      // height: 340px;
      // display: flex;
      // flex-direction: column;
      // align-items: start;
      // justify-content: space-between;
      h2 {
        margin: 8px 0 0 0;
        font-size: 20px;
        font-weight: 500;
        color: #2c8779;
        position: relative;
        padding-left: 16px;

        &::after {
          content: "";
          width: 4px;
          height: 20px;
          background: #2c8779;
          border-radius: 2px;
          position: absolute;
          top: 5px;
          left: 0;
        }
      }

      ::v-deep .KBQawards {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 20px 0 8px;
      }

      ::v-deep .KBQawards p {
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 1px;
        margin: 0;
        text-indent: 2em;
        letter-spacing: 1px;
        text-align: justify;

        .highlight {
          color: #2c8779;
        }
      }

      .btns {
        display: flex;

        >div {
          text-align: center;
          // line-height: 40px;
          padding: 10px 32px;

          &:first-child {
            margin-right: 40px;
          }

          &:hover {
            cursor: pointer;
          }
        }

        .detail {
          height: 40px;
          background: rgba(44, 135, 121, 0.3);
          border-radius: 3px;
          border: 1px solid #2c8779;
          font-size: 14px;
          font-weight: 400;
          color: #2c8779;
        }

        .sign {
          height: 40px;
          background: #2c8779;
          border-radius: 3px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}

.awards {
  margin-top: 50px;

  .main {
    width: 1400px;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    // align-items: center;

    >div {
      width: 472px;
      min-height: 273px;
      background: url("../assets/img/awards-backg/1.png");
      background-size: cover;
      padding: 27px 30px;

      &:nth-child(2) {
        background: url("../assets/img/awards-backg/2.png");
        background-size: cover;

        .awards-list .item>div:nth-child(2) {
          width: 206px;
        }
      }

      &:nth-child(3) {
        background: url("../assets/img/awards-backg/3.png");
        background-size: cover;
      }

      .title {
        border-bottom: 1px solid rgba(234, 234, 234, 0.3);
        text-align: center;
        padding-bottom: 10px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #ffffff;

        ::v-deep p {
          margin-bottom: 0 !important;
        }
      }

      .awards-list {
        padding-top: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #fff;
        font-size: 14px;

        .item {
          margin-bottom: 13px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          >div:nth-child(1) {
            img {
              margin-right: 10px;
            }
          }

          >div:nth-child(2) {
            // width: 229px;
            width: 250px;

            span:first-child {
              font-size: 16px;
              color: #00ffcd;
              margin: 0 5px;
            }
          }
        }

        .tips {
          padding-left: 22px;
        }
      }
    }
  }

  .mian-en>div {
    min-height: 357px;
  }
}

.support-enterprise {
  margin: 50px 0;
  padding: 30px 0;
  background: #f4f5f5;
  min-width: 1000px;

  .main {
    width: 1400px;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    justify-content: center;

    >div {
      display: inline-block;
      // width: 273px;
      margin: 0 8px 8px 0;

      &:last-child {
        margin-right: 0;
      }

      // &:nth-child(5n) {
      //   margin-right: 0;
      // }

      // &:nth-child(-n + 5) {
      //   margin-bottom: 8px;
      // }

      img {
        width: 100%;
        // width: 198px;
      }
    }
  }

  .main1 {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 10px;

    >div {
      display: inline-block;
      padding: 0 6px;
      text-align: center;

      // width: 273px;
      // margin-right: 8px;
      .support-title {
        margin-bottom: 0;
        font-size: 14px;
      }

      img {
        // width: 190px;
        width: 190px;
      }
    }
  }
}

// 侧边浮窗
.slider {
  width: 136px;
  height: 190px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  background-image: url("https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/kubuqi/kubuqi_slideBg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  text-align: center;
  padding: 0 4px;

  &-title {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    margin: 20px 0 6px 0;
  }

  >img {
    width: 88px;
    height: 88px;
  }

  &-sub {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
  }
}

@media screen and (max-width: 768px) {
  body {
    .slider {
      width: 110px;
      height: 170px;
      position: fixed;
      right: 4px;
      bottom: 4px;
      z-index: 9999;
      background-image: url("https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/kubuqi/kubuqi_slideBg.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      text-align: center;

      &-title {
        font-size: 10px;
        font-weight: 500;
        color: #333333;
        margin: 20px 0 3px 0;
      }

      >img {
        width: 80px;
        height: 80px;
      }

      &-sub {
        font-size: 10px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}

// 问卷调查弹窗
:deep .el-dialog__header {
  padding: 0;
}

:deep .el-dialog {
  background-color: transparent;
  box-shadow: 0 0 0 transparent;
}

:deep .el-dialog__body {
  padding: 0;
  text-align: center;

  >img {
    width: 600px;
    height: 600px;
  }
}

// 第二届库布其比赛弹窗
.contest-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 12;

  .content {
    max-width: 1400px;
    margin: 0 auto;

    main {
      margin-top: 250px;
      text-align: center;
      position: relative;

      >img {
        &:hover {
          cursor: pointer;
        }
      }

      >img:first-child {
        width: 524px;
      }

      .btn-close {
        position: absolute;
        top: -36px;
        right: 405px;
      }
    }
  }
}
</style>
